import HttpFactory from '../HttpFactory'
import type IBasicObjectResponse from '../interfaces/IBasicObjectResponse'

interface IWishlistResponse extends IBasicObjectResponse {
  data: {
    object_ids: string
  }
}

const extraHeaders = {
  'X-Requested-With': 'XMLHttpRequest'
}

class GuestWishlistModule extends HttpFactory {
  async getWishlistFromClient (): Promise<IWishlistResponse> {
    return await this.callFetch<IWishlistResponse>(
      'POST',
      'guest/wishlist/get-wishlist',
      null,
      extraHeaders
    )
  }

  async setWishlistFromClient (objectIds: number[]): Promise<IWishlistResponse> {
    return await this.callFetch<IWishlistResponse>(
      'POST',
      'guest/wishlist/set-wishlist',
      {
        object_ids: objectIds.join(',')
      },
      extraHeaders
    )
  }
}

export default GuestWishlistModule
